import React from 'react';
import cn from 'classnames';
import { Form, Radio } from 'antd';
import { RadioProps } from './types';
import './style.scss';

export const ToggleButton: React.FC<RadioProps> = ({
  className,
  name,
  label,
  options,
  rules,
  formItemProps,
  ...props
}) => {
  return (
    <div className={cn('form-item_toggle-button', className)}>
      <Form.Item name={name} label={label} rules={rules} labelCol={{ span: 24 }} {...formItemProps}>
        <Radio.Group buttonStyle="solid" optionType="button" options={options} {...props} />
      </Form.Item>
    </div>
  );
};
